/*
  TCP (2026-10-21): Framed / Framed + Mat without leaving the page.

  The framed versions of an artwork are separate products
  ([main-handle]-framed-us / -ca / -gb / -au). The Framed tiles on a main
  product, and the Print / Digital tiles on a framed product, are links to the
  other product (snippets/tcp-finish-links.liquid). This script turns those
  links into an in-place swap: the other product's whole product section
  (gallery, picker, buy box) is fetched and put in place of the current one,
  and the address bar stays on the MAIN product:

    /products/baby-raccoon?variant=123        main product, variant 123
    /products/baby-raccoon?framed=456         framed product, variant 456

  so a reload or a shared link opens the same thing (?framed= is picked up
  below and swapped in straight away). The page reached from an ad or an old
  link at /products/baby-raccoon-framed-us still works as a normal page; once
  the shopper switches finish there, the address moves to the main product.

  - Fetching: Shopify's section rendering (?section_id=). A framed product
    uses the same product template as its main product (set per product in
    admin), so its product section has the same id as the one on show. If
    that ever isn't so, the full page is fetched instead (and its section id
    remembered for the rest of the visit).
  - The other product is fetched ahead as soon as the pointer is over a tile
    (or a finger touches it), so the swap is usually instant.
  - Cmd / Ctrl / Shift / middle click still open the real link.
  - If anything fails, the link is simply followed.
*/
(function () {
  if (window.__tcpFinishSwap) return;
  window.__tcpFinishSwap = true;

  var style = document.createElement('style');
  style.textContent = 'a.tcp-finish-link.tcp-finish-link--loading{cursor:progress}';   // TCP edit (2026-10-31): no dimming -- the tile already shows as chosen
  document.head.appendChild(style);

  var SIB_RE = /-framed-(us|ca|gb|au)$/;
  var cache = {};
  var knownSection = {};

  function productKey(pathname) {
    var i = pathname.indexOf('/products/');
    return (i >= 0 ? pathname.slice(i) : pathname).replace(/\/$/, '');
  }
  function localePrefix() {
    var i = location.pathname.indexOf('/products/');
    return i > 0 ? location.pathname.slice(0, i) : '';
  }
  function isSiblingKey(key) { return SIB_RE.test(key); }
  function currentInfo() {
    var all = document.querySelectorAll('product-info[id^="MainProduct-"]');
    for (var i = 0; i < all.length; i++) {
      if (all[i].style.display !== 'none') return all[i];
    }
    return null;
  }

  var first = currentInfo();
  if (!first) return;
  var pageKey = productKey(location.pathname);
  knownSection[pageKey] = first.dataset.section;

  // The main product's path: this page's, or (on a framed page) the path the
  // Print / Digital tiles link to.
  var mainKey = pageKey;
  if (isSiblingKey(pageKey)) {
    var back = first.querySelector('a.tcp-finish-link');
    mainKey = back ? productKey(new URL(back.href, location.origin).pathname) : null;
  }

  function parse(text) { return new DOMParser().parseFromString(text, 'text/html'); }
  function infoIn(doc) { return doc && doc.querySelector('product-info[id^="MainProduct-"]'); }

  function fetchDoc(href) {
    if (cache[href]) return cache[href];
    var u = new URL(href, location.origin);
    var key = productKey(u.pathname);
    var sec = knownSection[key] || first.dataset.section;

    function full() {
      return fetch(u.pathname + u.search, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (t) {
          var d = parse(t);
          var p = infoIn(d);
          if (!p) throw new Error('no product section');
          knownSection[key] = p.dataset.section;
          return d;
        });
    }

    var p;
    if (sec) {
      var su = new URL(u.href);
      su.searchParams.set('section_id', sec);
      p = fetch(su.pathname + su.search, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) return full();
          return r.text().then(function (t) { var d = parse(t); return infoIn(d) ? d : full(); });
        });
    } else {
      p = full();
    }
    p = p.catch(function () { delete cache[href]; return null; });
    cache[href] = p;
    return p;
  }

  function setAddress(key, variantId) {
    if (!mainKey) return;
    var url = localePrefix() + mainKey;
    if (variantId) url += (isSiblingKey(key) ? '?framed=' : '?variant=') + variantId;
    try { history.replaceState(history.state, '', url + location.hash); } catch (e) {}
  }

  function selectedVariantId(info) {
    try {
      var s = info.querySelector('variant-selects [data-selected-variant]');
      var v = s && JSON.parse(s.textContent);
      if (v && v.id) return v.id;
    } catch (e) {}
    var input = info.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input ? input.value : null;
  }

  // Cross-fade the main picture from the product being replaced to the new
  // one: a copy of the old picture is laid over the new one and faded out
  // once the new picture has loaded (same look as the fade between options,
  // see tvp-frame-anim.liquid).
  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function pictureBox(info) {
    return info.querySelector('tvp-frame-viewer:not([data-mirror]) .tvp-fv__base');
  }
  // TCP edit (2026-10-30): picking a different presentation (Print / Framed / Digital)
  // slides the page back up to the picture, the way a new style or size does
  // (same rule as media-gallery.js: only when the top of the picture has scrolled
  // out of view, and the sticky header stays tucked away).
  function toPicture() {
    var info = currentInfo();
    var fv = info && info.querySelector('tvp-frame-viewer:not([data-mirror])');
    var pic = fv ? (fv.closest('.product__media-item') || fv) : (info && info.querySelector('.product__media-item.is-active, .product__media-item'));
    if (!pic) return;
    var r = pic.getBoundingClientRect();
    if (r.top > -0.5) return;
    var header = document.querySelector('sticky-header');
    if (header) header.dispatchEvent(new Event('preventHeaderReveal'));
    window.scrollTo({ top: r.top + window.scrollY, behavior: 'smooth' });
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-pres]');
    if (!t || !t.closest('product-info') || t.classList.contains('is-selected')) return;
    // a link to the other product slides once the swap is done (see swap())
    if (t.matches('a.tcp-finish-link')) return;
    setTimeout(toPicture, 350);
  }, true);

  function pictureGhost(info) {
    if (reduceMotion && reduceMotion.matches) return null;
    var box = pictureBox(info);
    if (!box) return null;
    var src = box.querySelector(':scope > .tvp-fv__stack:not([hidden])') || box.querySelector(':scope > img:not(.tvp-fv__ghost)');
    if (!src) return null;
    var g = src.cloneNode(true);
    g.removeAttribute('hidden');
    g.removeAttribute('id');
    g.removeAttribute('loading');
    g.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
    g.setAttribute('aria-hidden', 'true');
    g.classList.add('tvp-fv__ghost', 'tcp-swap-ghost');
    return g;
  }
  // TCP edit (2026-10-25): wait until the NEW product's picture is really drawn
  // before fading the old one away. With viewer art the new section's base is
  // only a light placeholder, and the live frame is drawn a moment later -- the
  // old fade went old picture -> placeholder -> live frame, which read as a
  // blink. Ready = the live stack is up (not still loading), or, when the
  // viewer can't draw this selection (digital, no art), the full base image
  // has loaded. At most 2s.
  function pictureReady(box) {
    var fv = box.closest('tvp-frame-viewer');
    var img = box.querySelector(':scope > img:not(.tvp-fv__ghost)');
    var imgOk = !img || (img.complete && img.naturalWidth > 0 && !img.hasAttribute('data-tvp-srcset'));
    if (!fv) return imgOk;
    if (fv.classList.contains('tvp-fv--live')) return !fv.classList.contains('tvp-fv--loading');
    if (!fv.enabled) return imgOk;
    if (fv.classList.contains('tvp-fv--loading') || !fv.renderSeq) return false;
    return imgOk;
  }
  function fadeIn(node, g) {
    var box = pictureBox(node);
    if (!box) return;
    box.appendChild(g);
    var started = false, t0 = Date.now();
    function start() {
      if (started) return;
      started = true;
      g.classList.add('tvp-fv__ghost--out');
      setTimeout(function () { g.remove(); }, 900);
    }
    (function wait() {
      if (started || !g.isConnected) return;
      if (pictureReady(box) || Date.now() - t0 > 2000) { requestAnimationFrame(start); return; }
      setTimeout(wait, 30);
    })();
  }

  // TCP edit (2026-10-25): the Presentation panel grows / shrinks smoothly when
  // the swap adds or removes the Frame Style row (Print / Digital <-> Framed),
  // and a newly shown row slides down into place. Measured before the swap
  // (old panel) and after it (new panel); Web Animations, nothing left behind.
  var PANEL_MS = 340;
  function finishPanel(info) { return info && info.querySelector('.tvp-option-group[data-option-name="Finish"]'); }
  // TCP edit (2026-10-31): a row's name without the chosen value the heading now shows
  // ("Presentation", not "PresentationFramed") -- otherwise the presentation row looked
  // new after every swap and slid in again
  function titleText(t) {
    var c = t.cloneNode(true);
    c.querySelectorAll('.tcp-head-val').forEach(function (x) { x.remove(); });
    return c.textContent.trim();
  }
  function rowTitles(panel) {
    return panel ? Array.prototype.map.call(panel.querySelectorAll('.tvp-finish-row-title'), titleText) : [];
  }
  function animatePanel(node, h0, oldTitles) {
    if ((reduceMotion && reduceMotion.matches) || !Element.prototype.animate) return;
    var panel = finishPanel(node);
    if (!panel) return;
    var h1 = panel.getBoundingClientRect().height;
    if (h0 > 2 && h1 > 2 && Math.abs(h1 - h0) > 2) {
      if (panel.__tvpA) { try { panel.__tvpA.cancel(); } catch (e) {} }
      // min + max height, not height: a <fieldset> never shrinks below its content
      var a = panel.animate(
        [{ minHeight: h0 + 'px', maxHeight: h0 + 'px', overflow: 'hidden' }, { minHeight: h1 + 'px', maxHeight: h1 + 'px', overflow: 'hidden' }],
        { duration: PANEL_MS, easing: 'cubic-bezier(0.25, 0.8, 0.3, 1)' }
      );
      panel.__tvpA = a;
      a.onfinish = a.oncancel = function () { if (panel.__tvpA === a) panel.__tvpA = null; };
    }
    // rows that weren't there before (e.g. Frame Style): fade + slide down
    panel.querySelectorAll('.tvp-finish-row-title').forEach(function (t) {
      if (oldTitles.indexOf(titleText(t)) >= 0) return;
      [t, t.nextElementSibling].forEach(function (el, i) {
        if (!el) return;
        el.animate(
          [{ opacity: 0, transform: 'translateY(-12px)' }, { opacity: 1, transform: 'none' }],
          { duration: PANEL_MS, delay: 60 + i * 40, easing: 'cubic-bezier(0.25, 0.8, 0.3, 1)', fill: 'backwards' }
        );
      });
    });
  }

  function swap(doc, href, opts) {
    var cur = currentInfo();
    var next = infoIn(doc);
    if (!cur || !next || typeof HTMLUpdateUtility === 'undefined') return false;
    var key = productKey(new URL(href, location.origin).pathname);
    next = next.cloneNode(true);
    // The address bar is handled here (it stays on the main product).
    next.setAttribute('data-update-url', 'false');
    next.querySelectorAll('.scroll-trigger').forEach(function (el) { el.classList.add('scroll-trigger--cancel'); });
    // The section being replaced must not touch the address or finish an
    // update it had started.
    cur.setAttribute('data-update-url', 'false');
    try { cur.abortController && cur.abortController.abort(); } catch (e) {}
    var modal = document.getElementById('ProductModal-' + cur.dataset.section);
    if (modal && !cur.contains(modal)) modal.remove();
    var ghost = pictureGhost(cur);
    var oldPanel = finishPanel(cur);
    var panelH0 = oldPanel ? oldPanel.getBoundingClientRect().height : 0;
    var panelTitles = rowTitles(oldPanel);
    HTMLUpdateUtility.viewTransition(cur, next, [], [function (node) {
      node.dataset.tcpProduct = key;
      if (ghost) fadeIn(node, ghost);
      // the picker builds its Frame Style row a moment later: measure just before the next paint
      requestAnimationFrame(function () { animatePanel(node, panelH0, panelTitles); });
      try { window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init(); } catch (e) {}
      try { window.ProductModel && ProductModel.loadShopifyXR(); } catch (e) {}
    }]);
    var now = currentInfo();
    setAddress(key, now ? selectedVariantId(now) : null);
    // TCP edit (2026-10-30): slide up to the picture -- again a moment later, once the
    // new product's picture has settled (a no-op if it's already in place)
    if (!opts || !opts.noScroll) { setTimeout(toPicture, 60); setTimeout(toPicture, 550); }
    return true;
  }

  // Later variant changes keep the address on the main product too.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var info = currentInfo();
      if (!info || !info.dataset.tcpProduct) return;
      // only changes made in the product section on show (not the hidden one
      // being replaced, which can still be finishing its own update)
      if (!event || !event.data || event.data.sectionId !== info.dataset.section) return;
      var v = event.data.variant;
      if (v && v.id) setAddress(info.dataset.tcpProduct, v.id);
    });
  }

  function linkFrom(target) {
    var a = target && target.closest && target.closest('a.tcp-finish-link');
    if (!a) return null;
    var info = a.closest('product-info');
    return info && info.id.indexOf('MainProduct-') === 0 ? a : null;
  }

  document.addEventListener('click', function (e) {
    var a = linkFrom(e.target);
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    var href = a.href;
    // TCP edit (2026-10-31): show the new choice at once (the heading follows), while
    // the other product loads -- the swap then lands on the same look
    if (a.hasAttribute('data-pres') && a.parentElement) {
      a.parentElement.querySelectorAll(':scope > [data-pres]').forEach(function (x) { x.classList.toggle('is-selected', x === a); });
    }
    a.classList.add('tcp-finish-link--loading');
    fetchDoc(href).then(function (doc) {
      a.classList.remove('tcp-finish-link--loading');
      if (!doc || !swap(doc, href)) location.href = href;
    });
  });

  function warm(e) {
    var a = linkFrom(e.target);
    if (a) fetchDoc(a.href);
  }
  document.addEventListener('pointerover', warm, { passive: true });
  document.addEventListener('touchstart', warm, { passive: true });
  document.addEventListener('focusin', warm);

  // Opened as /products/main?framed=456: show the framed product right away.
  var framedId = new URLSearchParams(location.search).get('framed');
  if (framedId && !isSiblingKey(pageKey) && /^\d+$/.test(framedId)) {
    var link = null;
    first.querySelectorAll('a.tcp-finish-link').forEach(function (a) {
      if (!link && isSiblingKey(productKey(new URL(a.href, location.origin).pathname))) link = a;
    });
    if (link) {
      var target = new URL(link.href, location.origin);
      target.searchParams.delete('option_values');   // TCP edit (2026-10-29): the tiles link by option values now
      target.searchParams.set('variant', framedId);
      first.style.transition = 'opacity 0.15s';
      first.style.opacity = '0';
      var reveal = setTimeout(function () { first.style.opacity = ''; }, 4000);
      fetchDoc(target.pathname + target.search).then(function (doc) {
        clearTimeout(reveal);
        if (!doc || !swap(doc, target.pathname + target.search, { noScroll: true })) first.style.opacity = '';
      });
    }
  }
})();